module.exports = __webpack_public_path__ + "img/pmaps-loading.47ab69d5.gif";